import { MijnRoute } from '../../mijn-navigatie.model';

export const BUDGET_CREATE: MijnRoute = {
    path: 'instellen',
    navigationEvent: 'toBudgetCreate',
    regex: /^\/budgetten\/instellen$/,
    webcomponent: 'mijn-budget-webcomponent',
    internalPath: '/instellen'
};
